import { useStaticQuery, graphql } from "gatsby"

export const useAllCategoryData = () => {
  return useStaticQuery(
    graphql`
      query allCategories {
        allDatoCmsCategory {
          edges {
            node {
              id
              title
              landingPageDiscoverMore {
                ...DiscoverMore
              }
            }
          }
        }
      }
    `
  ).allDatoCmsCategory.edges.flatMap((edge) => edge.node)
}
